module.exports = __webpack_public_path__ + "assets/military.f666df57.svg";